export default __webpack_public_path__ + "static/media/refreshments.1ccea73c.svg";